import AdminApproveTransaction from 'views/AdminApproveTransaction/AdminApproveTransaction.jsx';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import AdminApproveTrucker from 'views/AdminApproveTrucker/AdminApproveTrucker.jsx';
import Truckers from 'views/Truckers/AdminViewTruckers.jsx';
import LocalShipping from '@material-ui/icons/LocalShipping';
import DashboardRedirect from '../views/Dashboard/DashboardRedirect';

const approvalRoutes = [
  {
    path: '/approval/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: DashboardRedirect,
  },
  {
    collapse: true,
    path: '/approval/approve',
    name: 'Approve',
    icon: AssignmentTurnedIn,
    state: 'openApprove',
    views: [
      {
        path: '/approval/approve/transaction',
        name: 'Transaction',
        mini: 'T',
        component: AdminApproveTransaction,
      },
      {
        path: '/approval/approve/trucker',
        name: 'Trucker',
        mini: 'T',
        component: AdminApproveTrucker,
      },
    ],
  },

  {
    path: '/approval/truckers',
    name: 'View Truckers',
    icon: LocalShipping,
    component: Truckers,
  },
  {
    redirect: true,
    path: '/approval',
    pathTo: '/approval/dashboard',
    name: 'Dashboard',
  },
];
export default approvalRoutes;
